module.exports = __webpack_public_path__ + "static/media/Niv Saar.c4369b3d.png";